import { useMemo } from 'react'

import { useQueryGetAllItemCategories } from '@flecto/core/saas'
import { type CoreItemCategory } from '@flecto/types'

function orderCategories(categories: CoreItemCategory[]) {
  const parents = []
  const childrenMap = new Map()

  for (const cat of categories) {
    if (cat.parent_id === null) {
      parents.push(cat)
    } else {
      if (!childrenMap.has(cat.parent_id)) {
        childrenMap.set(cat.parent_id, [])
      }
      childrenMap.get(cat.parent_id).push(cat)
    }
  }

  parents.sort((a, b) => a.order - b.order)
  const result = []

  for (const parent of parents) {
    result.push(parent)
    if (childrenMap.has(parent.id)) {
      const childArr = childrenMap.get(parent.id)
      childArr.sort(
        (a: { order: number }, b: { order: number }) => a.order - b.order
      )
      result.push(...childArr)
    }
  }

  return result
}

export const useFlattenItemCategories = () => {
  const { data, isLoading, isError, error } = useQueryGetAllItemCategories()

  const flattenedCategories = useMemo(() => {
    return (data?.item_category || []).flatMap((category) => [
      category,
      ...(category.subcategories || []),
    ])
  }, [data])

  const categories = orderCategories(flattenedCategories)

  return {
    categories,
    isLoading,
    isError,
    error,
  }
}
